import { h } from "preact";
import MiniCartQuantity from "./mini-cart-quantity";
import MiniCartItemBadge from "./mini-cart-item-badge";
import StockMessage from "../../main-product/stock-status/stock-message";
import { Tag } from "../../helpers/icons";

export default function MiniCartItem({
  item,
  currency,
  swatchLimitEach,
  showStockAttribute,
  subdue,
}) {
  const isSwatch = item.properties?._is_swatch === "true";
  const stockMessageAttribute =
    showStockAttribute && item.properties?._stock_message;
  const fixedQuantity = isSwatch && swatchLimitEach === 1;
  const maxQuantity = () => {
    if (isSwatch) {
      return swatchLimitEach;
    }

    if (item.cartQuantityLimit) {
      return item.cartQuantityLimit;
    }

    return null;
  };

  const originalPrice = Math.max(item.price, item.original_price || 0);

  return (
    <div
      className={`mini-cart-item ${subdue ? "mini-cart-item--subdued" : ""}`}
    >
      <a href={item.url} className="mini-cart-item__image-wrapper">
        {item.featured_image ? (
          <img
            className="mini-cart-item__image"
            src={window.getSizedImageUrl(item.featured_image.url, "x200")}
            alt={item.featured_image.alt || item.product_title}
          />
        ) : (
          <div className="mini-cart-item__image mini-cart-item__image--blank"></div>
        )}
      </a>
      <div className="mini-cart-item__details">
        <div className="mini-cart-item__content">
          <div
            className="mini-cart-item__content-left"
            data-cart-item-variant={item.variant_id}
          >
            <div className="mini-cart-item__title-wrapper">
              <MiniCartItemBadge
                className="mini-cart-item__badge"
                item={item}
                position="Default"
              />
              <a href={item.url} className="mini-cart-item__title">
                {item.product_title}
              </a>
            </div>
            {!item.product_has_only_default_variant && (
              <div className="mini-cart-item__options">
                {item.options_with_values.map(({ name, value }) => (
                  <div className="mini-cart-item__option">{`${name}: ${value}`}</div>
                ))}
              </div>
            )}
            {item.stockMessageInputs && !showStockAttribute && (
              <StockMessage
                {...item.stockMessageInputs}
                localeStrings={window.localeStrings.cart.stock_message}
              />
            )}
            {!!stockMessageAttribute && (
              <div className="stock-message">
                <div
                  className={`stock-message__message stock-message__message--line-1`}
                  style={"color: var(--color-secondary)"}
                >
                  {stockMessageAttribute}
                </div>
              </div>
            )}
            {item.additionalData.discountAllocations?.length > 0 &&
              item.additionalData.discountAllocations.map(({ title }) => (
                <div className="mini-cart-item__discount-message">
                  <Tag />
                  {title}
                </div>
              ))}
            <MiniCartItemBadge
              className="mini-cart-item__inline-badge"
              item={item}
              position="Below price"
            />
          </div>
          <div className="mini-cart-item__content-right">
            <price-snippet
              className="mini-cart-item__price"
              DYNAMIC
              PRICE={item.final_line_price / 100}
              COMPARE-AT-PRICE={(originalPrice * item.quantity) / 100}
              CURRENCY={currency}
            ></price-snippet>
          </div>
        </div>
        <div className="mini-cart-item__footer">
          {fixedQuantity ? (
            <div className="mini-cart-item__fixed-qty">
              {window.localeStrings.cart.quantity.replace(
                "[count]",
                item.quantity,
              )}
            </div>
          ) : (
            <MiniCartQuantity item={item} max={maxQuantity()} />
          )}
          <button
            className="mini-cart-item__remove link link--x-small"
            onClick={() => window.updateCart({ updates: { [item.id]: 0 } })}
          >
            {window.localeStrings.cart.remove}
          </button>
        </div>
      </div>
    </div>
  );
}
